import React from 'react';
import PropTypes from 'prop-types';
import currencyFormatter from 'currency-formatter';
import styles from './StatisticBox.pcss';

class StatisticBox extends React.PureComponent {
    static propTypes = {
        subTitle: PropTypes.string,
        content: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
        type: PropTypes.string,
        code: PropTypes.string,
        className: PropTypes.string
    };

    formatContent = (content, type, className) => {
        if (type === 'currency') {
            const newContent = currencyFormatter.format(content, {code: this.props.code || 'USD'});
            const value = newContent.match(/[\w+\\,*]+\./)[0];
            const symbols = newContent.split(/[\w+\\,*]+\./);
            const location = newContent.startsWith(value);
            if (location) {
                return (
                    <div>
                        <span>{value}</span>
                        <span>{symbols[0]}</span>
                        <span className={styles.sup}>{symbols[1]}</span>
                    </div>
                );
            }

            return (
                <div>
                    <span>{symbols[0]}</span>
                    <span>{value}</span>
                    <span className={styles.sup}>{symbols[1]}</span>
                </div>
            );
        } else if (type === 'text') {
            return <div className={className}>{content}</div>;
        }
        return <div className={styles.normal}>{content}</div>;
    };

    render() {
        const {subTitle, content, type, className} = this.props;
        return (
            <div className={styles.container}>
                {this.formatContent(content, type, className)}
                <p>{subTitle}</p>
            </div>
        );
    }
}
export default StatisticBox;
